import { createContext } from "react";
import type { AppData } from "../types";

interface ProtectContextProps {
  data: AppData | null;
}

export const ProtectContext = createContext<ProtectContextProps>({
  data: null,
});
